import React from 'react';

/**
 * 加载中组件 - 显示加载状态指示器
 * @param {string} size - 尺寸: 'sm'|'md'|'lg'
 * @param {string} variant - 颜色变体: 'primary'|'secondary'|'success'|'danger'|'warning'|'info'|'light'|'dark'
 * @param {string} text - 加载中显示的文本
 * @param {boolean} fullPage - 是否占满整个页面
 * @param {string} className - 额外的CSS类名
 */
const Spinner = ({
  size = 'md',
  variant = 'primary',
  text,
  fullPage = false,
  className = '',
}) => {
  // 根据尺寸获取类名
  const getSizeClass = () => {
    switch (size) {
      case 'sm':
        return 'spinner-border-sm';
      case 'lg':
        return '';
      case 'md':
      default:
        return '';
    }
  };

  // 获取尺寸样式
  const getSizeStyle = () => {
    switch (size) {
      case 'sm':
        return {};
      case 'lg':
        return { width: '3rem', height: '3rem' };
      case 'md':
      default:
        return { width: '2rem', height: '2rem' };
    }
  };

  // 基本的 Spinner 组件
  const spinnerElement = (
    <div
      className={`spinner-border text-${variant} ${getSizeClass()} ${className}`}
      role="status"
      style={getSizeStyle()}
    >
      <span className="visually-hidden">加载中...</span>
    </div>
  );

  // 如果有文本，则添加文本
  const spinnerWithText = text ? (
    <div className="d-flex flex-column align-items-center">
      {spinnerElement}
      <span className="mt-3 text-center">{text}</span>
    </div>
  ) : (
    spinnerElement
  );

  // 如果是全页加载中
  if (fullPage) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        {spinnerWithText}
      </div>
    );
  }

  return spinnerWithText;
};

export default Spinner; 